<template>
  <div class="file-box">
    <template v-if="showImage">
      <img
        v-if="fileType === 'image'"
        @click="handleClick"
        src="../../../../assets/images/chat/image.png"
        alt=""
      />
      <img
        v-else
        :src="fileIcon || require('../../../../assets/images/chat/file.png')"
        alt=""
        @click="handleClick"
      />
    </template>
    <span
      v-show="false"
      class="upload-btn icon icon-file"
      :class="{ 'icon-image': fileType === 'image' }"
    >
      <input
        ref="fileUpload"
        v-if="!isMute"
        title="文件"
        type="file"
        data-type="file"
        accept="*"
        @change="sendUploadMessage"
      />
      <slot />
    </span>
    <select-file
      ref="selectFile"
      :hidden-upload="true"
      :type="fileType"
      @confirm="confirmSelectFile"
      :forbidSelect="forbidSelect"
      :limit="limit"
    />
  </div>
</template>

<script>
import { getAllMaterialId } from "@saas/server-api/src/course";
import { CONV_TYPE } from "@saas/components/src/utils/im/constants";
import SelectFile from "@saas/components/src/components/SelectFile";
import { checkPermission } from "@saas/components/src/utils/permission";
export default {
  props: {
    fileIcon: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 1,
    },
    isMute: {
      type: Boolean,
      default: false,
    },
    fileType: {
      type: String,
      default: "file",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: "",
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "",
    },
    onClick: {
      type: Function,
      default: null,
    },
  },
  data: function () {
    return {
      forbidSelect: [],
    };
  },
  components: { SelectFile },
  computed: {
    userRole() {
      return this.$store.getters["chat/userRoleAtGroup"];
    },
    isAdmin() {
      if (this.convType === CONV_TYPE.GROUP) {
        return (
          (this.userRole === 300 || this.userRole === 400) &&
          checkPermission([
            "action:material:file:view",
            "action:material:file:manage",
          ])
        );
      } else {
        return checkPermission([
          "action:material:file:view",
          "action:material:file:manage",
        ]);
      }
    },
    convType() {
      return this.$store.state.chat.currentConversation?.conv_type;
    },
    convId() {
      return this.$store.state.chat.currentConversation?.conv_id;
    },
  },
  methods: {
    handleClick(event) {
      // 如果传入了onClick函数则调用它，否则使用默认的checkUserPermission方法
      if (this.onClick) {
        this.onClick(event);
      } else {
        this.checkUserPermission(event);
      }
    },
    async checkUserPermission({ type }) {
      if (this.isMute) return;
      if (
        this.convType === CONV_TYPE.GROUP &&
        !(this.userRole === 300 || this.userRole === 400)
      ) {
        this.$refs?.fileUpload.dispatchEvent(new MouseEvent("click"));
      } else {
        let { code, data, message } = await this.$store.dispatch(
          "user/getUserPermissions"
        );
        if (code === 1) {
          let havePermission = checkPermission([
            "action:material:file:view",
            "action:material:file:manage",
          ]);
          if (type === "group-chat-file-upload") {
            havePermission =
              havePermission && checkPermission("action:course:file:manage");
            if (!havePermission) {
              this.$message.error("您没有上传文件的权限");
              return;
            }
          }
          if (havePermission) {
            this.handleUpload();
          } else {
            this.$refs?.fileUpload.dispatchEvent(new MouseEvent("click"));
          }
        } else {
          this.$message.error(message);
        }
      }
    },
    showFileUpload() {
      this.$refs?.fileUpload.dispatchEvent(new MouseEvent("click"));
    },
    confirmSelectFile(file) {
      if (this.limit === 1) {
        this.$emit("select", {
          type: "api",
          file: file[0],
        });
      } else {
        this.$emit("select", file);
      }
    },
    handleUpload() {
      if (this.disabled) {
        if (this.disabledTips) {
          this.$showToast(this.disabledTips);
        }
        return;
      }
      if (this.isMute) return;
      if (this.type === "courseFileUpload") {
        // 课程下的文件上传
        getAllMaterialId({
          course_id: this.convId,
        }).then((res) => {
          if (res.code === 1) {
            this.forbidSelect = res.data || [];
            this.$refs["selectFile"].showPopup(-1);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$refs["selectFile"].showPopup(-1);
      }
    },
    sendUploadMessage(e) {
      if (this.isMute) return;
      if (e.target.files.length > 0) {
        try {
          const files = e.target.files[0];
          this.$emit("select", {
            type: "sdk",
            file: files,
          });
        } catch (error) {
          console.log("sendUploadMessage", error);
        }
      }
      e.target.value = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.file-box {
  margin-right: 0 !important;
  & > img {
    cursor: pointer;
    width: 24px;
    height: 24px;
    margin-right: 20px;
  }
}
.icon-file {
  margin-right: 20px;
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  background-image: url("../../../../assets/images/chat/file.png");
  background-size: 100%;
  input {
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  &.icon-image {
    background-image: url("../../../../assets/images/chat/image.png");
  }
}
</style>
